<script>
  import { onMount } from 'svelte';

  let { parent, target, clickHandlerCallback = () => {} } = $props();

  onMount(() => {
    const clickHandler = (event) => {
      let elem = event.target;

      while (elem !== document.body) {
        if (elem === target) return;
        if (!elem) break;
        elem = elem.parentElement;
      }
      clickHandlerCallback();
    };

    parent.addEventListener('click', clickHandler);

    return () => {
      parent.removeEventListener('click', clickHandler);
    };
  });
</script>
